import { Box, Button as MuiLinkButton } from "@mui/material";
import React from "react";

export interface Props {
  message: string;
  disabled?: boolean;
  onClick: () => void;
}
function LinkButton({ message, disabled = false, onClick }: Props) {
  const style =
    "normal-case font-sans text-sm font-semibold text-primary-8 rounded-none bg-transparent shadow-none p-0 " +
    "hover:shadow-none hover:bg-default-white " +
    "active: bg-none" +
    "disabled:cursor-not-allowed disabled:shadow-none disabled:bg-default-white";
  const boxStyle =
    "w-fit border border-default-transparent hover:border-b-primary-8";
  return (
    <Box className={boxStyle} onClick={onClick}>
      <MuiLinkButton className={style} disabled={disabled}>
        {message}
      </MuiLinkButton>
    </Box>
  );
}

export default LinkButton;
